import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import PersonalList from './components/PersonalList';
import AttendanceControl from './components/AttendanceControl';
import AttendanceHistory from './components/AttendanceHistory';

export default function AdminPage() {
  const [activeTab, setActiveTab] = useState<'control' | 'personal' | 'historial'>('control');

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="mb-12">
            <h1 className="font-serif text-4xl md:text-5xl text-gray-900 font-bold mb-4">
              Control de Personal
            </h1>
            <p className="text-gray-600 text-lg">
              Gestiona la entrada y salida de tu equipo de trabajo
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="border-b border-gray-200">
              <div className="flex gap-2 p-2">
                <button
                  onClick={() => setActiveTab('control')}
                  className={`flex-1 px-6 py-3 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                    activeTab === 'control'
                      ? 'bg-amber-700 text-white'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  <i className="ri-time-line mr-2"></i>
                  Control de Asistencia
                </button>
                <button
                  onClick={() => setActiveTab('personal')}
                  className={`flex-1 px-6 py-3 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                    activeTab === 'personal'
                      ? 'bg-amber-700 text-white'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  <i className="ri-team-line mr-2"></i>
                  Personal
                </button>
                <button
                  onClick={() => setActiveTab('historial')}
                  className={`flex-1 px-6 py-3 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                    activeTab === 'historial'
                      ? 'bg-amber-700 text-white'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  <i className="ri-history-line mr-2"></i>
                  Historial
                </button>
              </div>
            </div>

            <div className="p-8">
              {activeTab === 'control' && <AttendanceControl />}
              {activeTab === 'personal' && <PersonalList />}
              {activeTab === 'historial' && <AttendanceHistory />}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
